<template>
  <!-- <div>AUTHENTICATE HERE</div> -->
  <div></div>
</template>

<script>
export default {
  name: "Auth",
};
</script>

<style lang="scss" scoped>
</style>